<template>
    <div class="flex flex-col h-full items-center justify-center lg:px-0 lg:py-0 px-4 py-10">
        <h4 class="text-center m-y-md md:w-1/2 w-full">{{ $t('sign_up.organization_choice_heading') }}</h4>
        <p class="md:w-2/3 text-center w-full">{{ $t('sign_up.organization_choice_info') }}</p>
        <form-progress-bar :steps="3" :current-step="1"></form-progress-bar>

        <div class="md:w-2/3 w-full">
            <button @click="selectOption('find')" class="border-b border-t border-gray-400 focus:outline-none flex group items-center py-3 w-full">
                <div class="bg-info-500 flex h-8 items-center justify-center mr-4 p-2 rounded w-8">
                    <svg class="block fill-current h-8 text-white w-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"/></svg>
                </div>
                <div class="flex flex-col flex-grow text-left">
                    <div class="font-bold text-sm">{{ $t('sign_up.find_organization_heading') }}</div>
                    <div>{{ $t('sign_up.find_organization_info') }}</div>
                </div>
                <div class="animated-chevron-transition pl-3 group-hover:pl-0 group-hover:pr-3">
                    <svg class="fill-current h-6 text-gray-700 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z"/></svg>
                </div>
            </button>
            <button @click="selectOption('create')" class="border-b border-gray-400 focus:outline-none flex group items-center py-3 w-full">
                <div class="bg-warning-500 flex h-8 items-center justify-center mr-4 p-2 rounded w-8">
                    <svg class="block fill-current h-8 text-white w-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M11 9h4v2h-4v4H9v-4H5V9h4V5h2v4zm-1 11a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"/></svg>
                </div>
                <div class="flex flex-col flex-grow text-left">
                    <div class="font-bold text-sm">{{ $t('sign_up.add_organization_heading') }}</div>
                    <div>{{ $t('sign_up.add_organization_info') }}</div>
                </div>
                <div class="animated-chevron-transition pl-3 group-hover:pl-0 group-hover:pr-3">
                    <svg class="fill-current h-6 text-gray-700 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z"/></svg>
                </div>
            </button>
        </div>

        <p class="pt-12 text-center" v-html="$t('sign_up.login_line', { linkOpen: '<a href=&quot;/&quot;>', linkClose: '</a>' })"></p>
    </div>
</template>

<script>
import FormProgressBar from './form-progress-bar.vue';

export default {
    components: {
        'form-progress-bar': FormProgressBar,
    },

    methods: {
        selectOption(value) {
            Bus.$emit('changeScreen', { hash: value, step: 2 });
        },
    },
};
</script>
